import React, { useEffect } from 'react';
import { useAlert } from '../hooks/useAlert';

export const AlertContainer: React.FC = () => {
  const { alerts, removeAlert } = useAlert();

  useEffect(() => {
    // Auto-remove alerts after 5 seconds
    alerts.forEach(alert => {
      const timer = setTimeout(() => {
        removeAlert(alert.id);
      }, 5000);

      return () => clearTimeout(timer);
    });
  }, [alerts, removeAlert]);

  if (alerts.length === 0) {
    return null;
  }

  return (
    <div style={{ position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 1000 }}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`alert alert-${alert.type}`}
          style={{
            padding: '15px 20px',
            borderRadius: '12px',
            margin: '10px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            animation: 'slideIn 0.3s ease',
            minWidth: '300px',
            maxWidth: '500px'
          }}
        >
          <span>
            {alert.type === 'success' ? '✅' : 
             alert.type === 'warning' ? '⚠️' : '❌'}
          </span>
          <span>{alert.message}</span>
          <button
            onClick={() => removeAlert(alert.id)}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              cursor: 'pointer',
              marginLeft: 'auto',
              padding: '0 5px'
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};